<!-- SUCCESS screen - Plan was ADDED - but not Active yet -->
<div class="bp-modal mod-lg">
	<bp-modal-header header [title]="getTitle() | translate: [getTradable().getSymbol(false, true)]">
		<a class="font-semibold" (click)="close()" (keydown.enter)="close()" [tabIndex]="0" right>
			{{ "close" | translate }}
		</a>
	</bp-modal-header>

	<success-screen bgImage="coinsCrypto">
		<div content>
			<div class="success-content-inner">
				<div class="success-symbol mod-green mb-20 mt-70">
					<span class="bpi__icon-check large-weight"></span>
				</div>
				<div class="success-headline mb-15">{{ "savings_success_plan_processed_title" | translate }}</div>
				<p class="text-center mb-15 swap-success-text">
					<span>{{ "savings_success_check_plan_status_description" | translate }}</span>
					<br />
				</p>
			</div>
		</div>
	</success-screen>

	@if (stakingVm$ | async) {
		@if (showVisionWarning) {
			<p class="swap-success-text">
				{{
					"auto_staking_trade_success_vision_warning"
						| translate: [getTradable().getName(), getTradable().getSymbol()]
				}}
			</p>
		}
	}
	<div class="bp-modal-body-section">
		<div class="mb-50 text-center">
			<a (click)="goToSavings()">{{ "recurring_buy_success_screen_goto" | translate }}</a>
		</div>
		<!-- Vision Banner -->
		@let visionSavingBenefitFF = visionSavingBenefitFF$ | async;
		@let visionSavingBenefit = visionSavingBenefit$ | async;
		@let isUkUser = isUkUser$ | async;

		@if (visionSavingBenefitFF && showVisionBanner && !isUkUser) {
			<div class="vision-banner">
				<mo-success-vision-component
					[bannerState]="VisionBannerState.VISIONFEENOTACTIVE"
					[feeAmount]="visionSavingBenefit.feeDiscount > 0 ? visionSavingBenefit.feeDiscount : visionFeeFromCookie"
					[isVision]="isVision"
					(click)="handleBannerClick()"></mo-success-vision-component>
			</div>
		}
		<!-- Vision Banner -->
		<div class="mb-50 text-center">
			<button (click)="addNewSavingsPlan()" class="btn btn-primary btn-inverse" type="button">
				{{ "recurring_buy_success_screen_add_new" | translate }}
			</button>
		</div>
		<div class="text-center">
			<button
				(click)="close()"
				(keydown.enter)="close()"
				[tabIndex]="0"
				class="btn btn-primary btn-success-modal"
				type="button">
				<strong>{{ "close" | translate }}</strong>
			</button>
		</div>
	</div>
</div>
